import type { GameState, GameAction } from '../game/types';
import { generateCommentary } from '../services/gemini';
import { Icons } from './Icons';

type Props = {
  state: GameState;
  dispatch: React.Dispatch<GameAction>;
};

export function WinScreen({ state, dispatch }: Props) {
  if (state.modalType !== 'winner' || !state.winner) return null;
  const { winner, customApiKey, aiCommentary, isGeneratingCommentary } = state;
  const winnerName = winner.players.map((p) => p.name).join(' & ');
  const winnerFruits = winner.players[0]?.fruits ?? 0;

  const handleGenerate = async () => {
    if (isGeneratingCommentary || aiCommentary) return;
    if (!customApiKey) {
      dispatch({ type: 'COMMENTARY_ERROR', text: '（AI 講評連線失敗，請見諒）' });
      return;
    }
    dispatch({ type: 'COMMENTARY_START' });
    try {
      const text = await generateCommentary(
        winner.players.map((p) => p.name),
        winnerFruits,
        customApiKey,
      );
      dispatch({ type: 'COMMENTARY_SUCCESS', text });
    } catch {
      dispatch({ type: 'COMMENTARY_ERROR', text: '（AI 講評連線失敗，請見諒）' });
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 overflow-y-auto py-10 animate-pop-in">
      <div className="bg-white p-8 rounded-3xl shadow-2xl max-w-md w-full text-center border-4 border-yellow-400 mt-10 relative overflow-hidden">
        <div className="text-6xl mb-4 animate-bounce">🏆</div>
        <h2 className="text-4xl font-black text-gray-800 mb-2">最後的倖存者！</h2>
        <div className="bg-yellow-50 p-6 rounded-2xl mb-6 border-2 border-yellow-100">
          <p className="text-yellow-700 font-bold mb-2">獲勝農夫</p>
          <div className="text-3xl font-black text-gray-800 mb-2">{winnerName}</div>
          <div className="text-green-600 font-bold bg-white inline-block px-4 py-1 rounded-full shadow-sm">
            擁有 {winnerFruits} 顆水果
          </div>
        </div>
        <div className="mb-6 p-4 bg-blue-50 rounded-xl text-left border border-blue-100">
          <div className="flex justify-between items-center mb-2">
            <h3 className="font-bold text-blue-800 flex items-center gap-1">
              <Icons.Sparkles /> AI 戰況速報
            </h3>
            {!aiCommentary && !isGeneratingCommentary && (
              <button
                onClick={() => void handleGenerate()}
                className="text-xs bg-blue-500 text-white px-3 py-1 rounded-full font-bold hover:bg-blue-600"
              >
                生成
              </button>
            )}
          </div>
          {isGeneratingCommentary ? (
            <div className="text-gray-400 text-sm animate-pulse">AI 主播打字中...</div>
          ) : (
            <div className="text-sm text-gray-700 leading-relaxed">{aiCommentary}</div>
          )}
        </div>
        <button
          onClick={() => dispatch({ type: 'GO_TO_INTRO' })}
          className="w-full bg-green-500 hover:bg-green-600 border-b-4 border-green-700 text-white py-3 rounded-xl font-bold text-lg btn-3d"
        >
          再玩一次
        </button>
      </div>
    </div>
  );
}
